import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import i18n from './i18n/lang.js'
import store from './store'
import axios from 'axios'
import VCalendar from 'v-calendar'

Vue.use(VCalendar)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

/**
* http配置
*/

// 设置超时时间
axios.defaults.timeout = 160000

Vue.config.productionTip = false
Vue.prototype.$http = axios

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)

console.log("======created main.js=====");
// 检测用户浏览器类型
const userAgent = window.navigator.userAgent;
const isIE = /MSIE|Trident/.test(userAgent);
//const isIE = userAgent.indexOf('Edge') > -1;
console.log(isIE);
if (isIE) {
  // 如果是IE浏览器，发出警告并拒绝连接
  alert("您正在使用的流覽器IE不被支持，建議使用Chrome、Edge、Firefox等現代化流覽器訪問該應用！");
//  window.location.href = 'http://140.128.77.36:88/'
  window.location.href = 'https://sra.ncut.edu.tw/'
} else {
  // 如果不是IE浏览器，正常加载Vue应用程序
  // 全域導航鉤子
  router.beforeEach((to, from, next) => {
    const { name, path } = to;
    console.log("== OpenView ==");
    next();
  })

  new Vue({
    router,
    store,
    i18n,
    data: {
      sysId: 11
    },
    methods: {
      getConfigureInfo: function (sysId) {
        return this.$http
          .get('./WebApi/Setting/GetConfigureList/'.concat(sysId))
      },
    },
    async created() {
      var vm = this;
      vm.$store.dispatch('setSysId', this.sysId);
      this.$http.all([vm.getConfigureInfo(this.sysId)])
        .then(vm.$http.spread(function (conInfo, sysInfo) {
          vm.$store.dispatch('setSetting', JSON.parse(conInfo.data))
        }))
    },
    render: h => h(App)
  }).$mount('#app')

  // http请求拦截器
  axios.interceptors.request.use(config => {
    console.log('== Help ==');
    if (store.getters.getCount === 0) {
      store.dispatch('toggleLoading', true)
    }
    store.dispatch('actionIncrease')
    return config
  }, error => {
    store.dispatch('actionDecrease')
    if (store.getters.getCount === 0) {
      store.dispatch('toggleLoading', false)
    }
    return Promise.reject(error)
  })

  // http响应拦截器
  axios.interceptors.response.use(data => {
    store.dispatch('actionDecrease')
    if (store.getters.getCount === 0) {
      store.dispatch('toggleLoading', false)
    }
    return data
  }, error => {
    store.dispatch('actionDecrease')
    if (store.getters.getCount === 0) {
      store.dispatch('toggleLoading', false)
    }
    var originalRequest = error.config;
    if (error.code == 'ECONNABORTED' && error.message.indexOf('timeout') != -1 && !originalRequest._retry) {
      originalRequest._retry = true
      return axios.request(originalRequest);
    } else {
      store.dispatch('actionResetCount')
      store.dispatch('toggleLoading', false)

      if (error && error.response) {
        switch (error.response.status) {
          case 401:
            console.log("401 Unauthorized");
            break;
          case 404:
            console.log("找不到該頁面");
            break;
          case 500:
            console.log("伺服器出錯");
            break;
          case 503:
            console.log("服務失效");
            break;
          default:
            console.log(`連接錯誤${error.response.status}`);
        }
      } else {
        console.log("連接到服務器失敗");
      }
    }
    return Promise.reject(error)
  })
}
